import React, { useEffect, useRef } from 'react';
import { useBrand } from '../../context/AuthContext';

const Footer = () => {
  const { brand } = useBrand();
  const sealContainerRef = useRef(null);

  useEffect(() => {
    const container = sealContainerRef.current;
    if (!container) {
      return undefined;
    }

    if (!brand?.sealScriptUrl) {
      container.innerHTML = '';
      container.dataset.sealUrl = '';
      return undefined;
    }

    const currentSealUrl = container.dataset.sealUrl;
    if (currentSealUrl && currentSealUrl !== brand.sealScriptUrl) {
      container.innerHTML = '';
    }

    const existingScript = container.querySelector('script[data-godaddy-seal="true"]');
    if (!existingScript) {
      const script = document.createElement('script');
      script.async = true;
      script.type = 'text/javascript';
      script.src = brand.sealScriptUrl;
      script.dataset.godaddySeal = 'true';
      container.appendChild(script);
    }

    container.dataset.sealUrl = brand.sealScriptUrl;

    return undefined;
  }, [brand?.sealScriptUrl]);

  return (
    <div className="text-center text-muted small">
      {brand && (
        <p className="mt-2 mb-0">
          &copy; {new Date().getFullYear()} {brand.longName}
        </p>
      )}
      <small>
        <a
          className="text-decoration-none"
          href="https://www.mdu.com/legal-statement"
        >
          Legal Statement
        </a>
      </small>
        <div className="text-center mt-4">
          <span id="siteseal" ref={sealContainerRef}></span>
        </div>
    </div>
  );
};

export default Footer;
